import { adminApi } from '~/api'
import { useQuery } from '@tanstack/react-query'

const courseParticipantsQueryKey = (id) => ['courses', id, 'students']
export const useParticipantsQuery = (id) =>
  useQuery({
    queryKey: courseParticipantsQueryKey(id),
    queryFn: async () => {
      const { data } = await adminApi.getCourseParticipants(id)
      return data.data
    }
  })
